 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		46: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"006b79ad17f570b14bda91870d03661552bc44a2","2":"b637e9a5","3":"component---src-templates-event-singular-tsx","4":"6b0e0a3f262fa84c647c7dab4aa28a14d5e888b9","5":"0b7b90cd","6":"1e0e1e1ce24732d582f3c2e6cc878c4206da2334","7":"component---src-pages-products-bare-metal-cloud-tsx","8":"67d02f1e27459dbd9756319bf5aa76dc2a497d5f","9":"component---src-pages-index-tsx","10":"component---src-pages-about-us-tsx","11":"component---src-pages-customer-stories-tsx","12":"component---src-pages-products-cloud-wan-tsx","13":"component---src-pages-solutions-china-tsx","14":"component---src-pages-solutions-gaming-tsx","15":"5e88fd55","17":"component---src-pages-404-tsx","18":"component---src-pages-by-the-numbers-china-tsx","19":"component---src-pages-by-the-numbers-india-tsx","20":"component---src-pages-careers-tsx","21":"component---src-pages-contact-us-tsx","22":"component---src-pages-ethics-and-compliance-tsx","23":"component---src-pages-gameeq-tsx","24":"component---src-pages-legal-tsx","25":"component---src-pages-partners-channel-partner-tsx","26":"component---src-pages-partners-reseller-partner-tsx","27":"component---src-pages-partners-solutions-partner-tsx","28":"component---src-pages-products-cloud-networking-tsx","29":"component---src-pages-products-content-delivery-network-tsx","30":"component---src-pages-products-edge-data-center-services-tsx","31":"component---src-pages-products-ip-transit-tsx","32":"component---src-pages-products-professional-services-tsx","33":"component---src-pages-service-level-agreement-tsx","34":"component---src-pages-solutions-cloud-service-providers-tsx","35":"component---src-pages-solutions-hybrid-cloud-tsx","36":"component---src-pages-solutions-media-entertainment-tsx","37":"component---src-pages-support-tsx","38":"component---src-pages-widget-footer-tsx","39":"component---src-pages-widget-speed-test-tsx","40":"component---src-pages-zenlayer-insider-tsx","41":"component---src-templates-customer-story-tsx","42":"component---src-templates-dc-tsx","43":"component---src-templates-documentation-tsx","44":"component---src-templates-event-tsx"}[chunkId]||chunkId) + "-" + {"1":"8373e72126a7386c8050","2":"3e8037b8c3a7ee5b4ae3","3":"e07033c7f6edea5cad60","4":"0a5a497fb422aa9d9823","5":"c21aca22f7e297c6286d","6":"83204d6eea011c9f23ec","7":"3e959112fd1a5599ac43","8":"d329cff4c8c9d7029466","9":"0c5feefb47bd0ec2037a","10":"4073ad3a59630d159499","11":"a778242b39967a9344a2","12":"03bc4da9411ebd889b9b","13":"d45f0c87e3cfdda39b13","14":"c043061a7077e40d8bf2","15":"11737e62b250496a0507","17":"a2ec9b31aa472917b83b","18":"74a301f5df4c9930ee26","19":"a2cfa14a38ec37ebcced","20":"32817da6f83fdf557ac6","21":"9e1dedf846c3fa862161","22":"95adf5bc81e96054cd65","23":"819d8216cbe8b8b18534","24":"2fd3851ea1cb4bffb45d","25":"f54f84f4e3817a6bd4a5","26":"76a96b4e4d1e734e5b75","27":"45a564763156508baa57","28":"a86449d48b0e8c6a12b8","29":"187fe9044cb220811896","30":"8a66930817c1839cd5f0","31":"08b5888d65bd1899a576","32":"4de33c2fe19d61b4c399","33":"ff6f4041d4b423c942f3","34":"503fd702bb13be768c0d","35":"81013bc04fcb7a2a1d86","36":"3f83f63c403bb6c5ee66","37":"67ee5092a0a995def31f","38":"b75accedfc7e134690ee","39":"2c40e4ac05ae36da0f17","40":"82ced6a093023cbd463b","41":"71954ebe6f1e011c00cd","42":"ce538f2fe656c0972b35","43":"e750a69c621d8a59da72","44":"7eeb890bec19ad9e6a00"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
